import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import WhyOrthodox from "@/components/WhyOrthodox";
import Values from "@/components/Values";
import Locations from "@/components/Locations";
import Activities from "@/components/Activities";
import Leadership from "@/components/Leadership";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Maintenance = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-anthracite text-cream px-6 text-center" data-testid="ghost-maintenance">
    <div className="pointer-events-none absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[400px]" style={{ background: "radial-gradient(ellipse, rgba(198,156,34,0.12) 0%, transparent 65%)" }} />
    <div className="relative w-20 h-20 rounded-full border border-gold/40 flex items-center justify-center" style={{ background: "rgba(198,156,34,0.08)" }}>
      <span className="font-accent italic text-4xl font-semibold" style={{ color: "#E5C76B" }}>B</span>
    </div>
    <p className="relative mt-6 text-[11px] uppercase tracking-[0.3em] text-cream/50">Brotherhood of Eden</p>
    <h1 className="relative mt-4 text-3xl sm:text-4xl font-semibold tracking-tight">Die Seite ist momentan nicht erreichbar</h1>
    <p className="relative mt-4 max-w-md text-cream/65">Wir sind gleich wieder für dich da. Bitte versuche es später noch einmal.</p>
    <p className="relative mt-2 max-w-md text-sm text-cream/40">Le site est momentanément indisponible · The site is currently unavailable</p>
  </div>
);

const Home = () => {
  const [ghost, setGhost] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/site/status`)
      .then(({ data }) => setGhost(!!data.ghost_mode))
      .catch(() => setGhost(false));
  }, []);

  useEffect(() => {
    if (ghost !== false) return;
    if (sessionStorage.getItem("boe_visit_tracked")) return;
    sessionStorage.setItem("boe_visit_tracked", "1");
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/track/visit`, { path: "/" })
      .catch(() => {});
  }, [ghost]);

  if (ghost === null) {
    return <div className="min-h-screen flex items-center justify-center bg-anthracite text-cream"><Loader2 size={28} className="animate-spin" style={{ color: "#E5C76B" }} /></div>;
  }

  if (ghost) return <Maintenance />;

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <Hero />
        <About />
        <WhyOrthodox />
        <Values />
        <Locations />
        <Activities />
        <Leadership />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
